import DashboardPageScrollContainer from './DashboardPageScrollContainer'

export default DashboardPageScrollContainer
